import React from 'react';
import { Box, Image, Text, VStack, Flex, Link, IconButton, useColorModeValue } from '@chakra-ui/react';
import { FaSpotify, FaYoutube, FaApple } from 'react-icons/fa6';

const MusicCard = ({ song }) => {
  const cardBg = useColorModeValue('brand.800', 'brand.800');
  const titleColor = useColorModeValue('brand.300', 'brand.300');
  const textColor = useColorModeValue('brand.600', 'brand.600');
  const accentColor = useColorModeValue('brand.accent', 'brand.accent');
  const secondaryAccentColor = useColorModeValue('brand.secondaryAccent', 'brand.secondaryAccent');

  return (
    <Box
      w={{ base: "280px", md: "250px" }} // Responsive width for card
      borderRadius="xl" // Rounded corners for the card
      overflow="hidden" // Ensure content stays within bounds
      boxShadow="lg" // Card shadow
      bg={cardBg} // Background color from theme
      p={4} // Padding inside the card
      transition="transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out" // Smooth transition for hover effects
      _hover={{ transform: 'translateY(-5px)', boxShadow: 'xl' }} // Lift effect on hover
    >
      <VStack spacing={4} align="stretch">
        {/* Album Art */}
        <Image
          src={song.thumbnailUrl}
          alt={`Album art for ${song.title}`}
          objectFit="cover" // Cover the area, cropping if necessary
          w="100%"
          h="auto"
          borderRadius="lg" // Rounded corners for image
          boxShadow="md" // Image shadow
          fallbackSrc="https://placehold.co/300x300/4A5568/FFFFFF?text=No+Image" // Fallback image if URL is broken
        />

        {/* Song Title and Release Date */}
        <Text fontSize="xl" fontWeight="bold" color={titleColor} noOfLines={1}>
          {song.title}
        </Text>
        <Text fontSize={"xs"} marginTop={-5} >
            by {song.artist}
        </Text>
        <Text fontSize="sm" color={textColor}>
          Released: {song.releaseDate}
        </Text>
        

        {/* Links to Streaming Platforms */}
        <Flex justifyContent="center" gap={3} mt={2}>
          {song.links.spotify && ( // Conditionally render Spotify link
            <IconButton
              as={Link} // Use Link component for external navigation
              href={song.links.spotify}
              isExternal // Opens in new tab
              aria-label="Listen on Spotify"
              icon={<FaSpotify />}
              size="md"
              bg={accentColor}
              color="white"
              borderRadius="full"
              _hover={{ bg: secondaryAccentColor, transform: 'scale(1.1)' }}
            />
          )}
          {song.links.youtube && ( // Conditionally render YouTube link
            <IconButton
              as={Link}
              href={song.links.youtube}
              isExternal
              aria-label="Watch on YouTube"
              icon={<FaYoutube />}
              size="md"
              bg={accentColor}
              color="white"
              borderRadius="full"
              _hover={{ bg: secondaryAccentColor, transform: 'scale(1.1)' }}
            />
          )}
          {song.links.appleMusic && ( // Conditionally render Apple Music link
            <IconButton
              as={Link}
              href={song.links.appleMusic}
              isExternal
              aria-label="Listen on Apple Music"
              icon={<FaApple />}
              size="md"
              bg={accentColor}
              color="white"
              borderRadius="full"
              _hover={{ bg: secondaryAccentColor, transform: 'scale(1.1)' }}
            />
          )}
        </Flex>
      </VStack>
    </Box>
  );
};

export default MusicCard;